import type { ReactNode } from 'react';

import { XMobileBottomNav } from './x-mobile-bottom-nav';
import { XMuiThemeProvider } from './x-mui-theme-provider';

type MobileLayoutProps = {
  readonly children?: ReactNode;
};

export function XMobileLayout(props: MobileLayoutProps) {
  const { children } = props;

  return (
    <XMuiThemeProvider>
      {children}
      <XMobileBottomNav />
    </XMuiThemeProvider>
  );
}
